import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxFileManagerModule } from 'devextreme-angular';

@Component({
    selector: 'app-project-sandbox',
    imports: [CommonModule, DxFileManagerModule],
    templateUrl: './project-sandbox.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./project-sandbox.component.css']
})
export class ProjectSandboxComponent {
  sandboxFiles = new Array();
}
